export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_3a65f364-f8cc-476a-886c-ed59a87eeab6/artifacts/bh03a293_logo%20pino%20verde%20fact.jpg";

export const HERO_IMAGE = "/generated/hero.jpg";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1759763823587-c8bd07fca246";

export const SERVICES_IMAGE = "/generated/services.jpg";

export const CATALOG_IMAGE =
  "https://images.pexels.com/photos/209230/pexels-photo-209230.jpeg";

export const CONTACT = {
  email: "ventas1@pinoverdecr.com",
  phone: "2244-1013",
  phoneAlt: "2244-7864",
  sales: "2566-0228",
  whatsapp: "8726-6000",
  whatsappRaw: "50687266000",
  address: "175 N. Esc. Rubén Darío, Sta. Rosa, Santo Domingo de Heredia",
  city: "Heredia, Costa Rica",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Santo+Domingo+de+Heredia+Costa+Rica",
};

export const NAV_ITEMS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Catálogo", href: "#catalogo" },
  { label: "Aliados", href: "#aliados" },
  { label: "Contacto", href: "#contacto" },
];

export const STATS = [
  { value: "23", label: "Años de experiencia", suffix: "+" },
  { value: "500", label: "Productos en catálogo", suffix: "+" },
  { value: "20", label: "Marcas aliadas", suffix: "+" },
  { value: "100", label: "Empresas protegidas", suffix: "%" },
];

export const SERVICES = [
  {
    id: "analisis",
    title: "Análisis de Riesgos",
    overline: "Servicio 01",
    desc:
      "Identificamos posibles riesgos y problemas dentro de su empresa, evaluando puestos de trabajo, procesos y entornos para anticipar accidentes antes de que ocurran.",
    bullets: [
      "Diagnóstico in-situ",
      "Matriz de riesgos",
      "Reporte ejecutivo",
    ],
  },
  {
    id: "asesoria",
    title: "Asesoría Especializada",
    overline: "Servicio 02",
    desc:
      "Acompañamos a su equipo con asesoría sobre cómo mitigar y corregir riesgos, cumplir con la normativa de salud ocupacional y reducir pólizas de seguro.",
    bullets: [
      "Cumplimiento normativo",
      "Capacitación a colaboradores",
      "Optimización de pólizas",
    ],
  },
  {
    id: "equipo",
    title: "Equipo Especializado",
    overline: "Servicio 03",
    desc:
      "Suministramos el equipo de protección personal exacto para cada necesidad, con marcas certificadas y soporte técnico continuo.",
    bullets: [
      "+500 productos certificados",
      "Marcas líderes mundiales",
      "Entrega y reposición",
    ],
  },
];

export const CATEGORIES = [
  {
    id: "guantes",
    name: "Guantes",
    code: "01",
    desc:
      "Químicos, mecánicos, anticorte, dieléctricos, térmicos, desechables y para soldadura.",
    icon: "Hand",
  },
  {
    id: "cascos",
    name: "Cascos",
    code: "02",
    desc:
      "V-Guard, ratchet y de ala entera. Suspensión nylon, múltiples colores normados.",
    icon: "HardHat",
  },
  {
    id: "calzado",
    name: "Calzado de Seguridad",
    code: "03",
    desc:
      "Punteras de acero, carbón y composite. Dieléctrico, antideslizante e impermeable.",
    icon: "Footprints",
  },
  {
    id: "auditiva",
    name: "Protección Auditiva",
    code: "04",
    desc:
      "Orejeras, tapones desechables y reutilizables, arco-tapones (NRR 21–33 dB).",
    icon: "Ear",
  },
  {
    id: "visual",
    name: "Protección Visual y Facial",
    code: "05",
    desc:
      "Anteojos anti-empaño, gafas, caretas faciales y para soldadura autógena.",
    icon: "Eye",
  },
  {
    id: "respiratoria",
    name: "Protección Respiratoria",
    code: "06",
    desc:
      "Mascarillas N95/N99, respiradores media cara y full-face con cartuchos.",
    icon: "Wind",
  },
  {
    id: "altura",
    name: "Protección de Altura",
    code: "07",
    desc:
      "Arneses, líneas de vida sencillas, dobles y retráctiles, puntos de anclaje.",
    icon: "Mountain",
  },
  {
    id: "soldadura",
    name: "Equipo de Soldadura",
    code: "08",
    desc:
      "Caretas electrónicas, mangas, polainas, delantales de cuero y jackets ignífugas.",
    icon: "Flame",
  },
  {
    id: "ropa",
    name: "Ropa de Protección",
    code: "09",
    desc:
      "Capas impermeables, gabachas, kimonos Tyvek/Tichem, trajes para frío.",
    icon: "Shirt",
  },
  {
    id: "emergencia",
    name: "Equipos de Emergencia",
    code: "10",
    desc:
      "Duchas y lavaojos Speakman, control de derrames, candados de seguridad.",
    icon: "ShowerHead",
  },
  {
    id: "senalizacion",
    name: "Señalización",
    code: "11",
    desc:
      "Conos 18\"–36\", chalecos visibles, trafi-tambos y cintas de precaución.",
    icon: "TrafficCone",
  },
];

// Real brand logos hosted on Wikimedia Commons (via Special:FilePath)
export const PARTNERS = [
  {
    name: "3M",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/3M_wordmark.svg",
  },
  {
    name: "Ansell",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Ansell_Logo.svg",
  },
  {
    name: "Dräger",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Dr%C3%A4ger_Logo.svg",
  },
  {
    name: "Honeywell",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Honeywell_logo.svg",
  },
  {
    name: "Uvex",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Uvex_Logo.svg",
  },
  {
    name: "MSA Safety",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/MSA_logo.svg",
  },
  {
    name: "DuPont",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/DuPont_logo.svg",
  },
  {
    name: "Tyvek",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Tyvek_logo.svg",
  },
];
